import SignUpForm from './component'

export default SignUpForm
